import { IAuthentication } from 'domain/usecases';
import { FormikValues, useFormik } from 'formik';
import Cookies from 'js-cookie';
import { useAuth } from 'presentation/app/hooks/useAuth';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { LoginView } from './view';

import '@repo/ui';
import { removeCpfMask } from '@repo/ui';
import { InvalidCredentialsError } from 'domain/errors';

interface IAuth {
  authentication: IAuthentication;
}

export const Login = ({ authentication }: IAuth) => {
  const [error, setError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('Dados de autenticação inválidos');
  const [loader, setLoader] = useState<boolean>(false);
  const [passwordShow, setPasswordShow] = useState<boolean>(false);

  const navigate = useNavigate();
  const { saveAuth, setCurrentUser } = useAuth();

  const savedCredentials = Cookies.get('@saveCredentialsUser');

  const validation: FormikValues = useFormik({
    enableReinitialize: true,

    initialValues: {
      cpf: savedCredentials ? JSON.parse(savedCredentials)?.cpf : '',
      password: '',
      keepMeSignedIn: savedCredentials ? true : false,
    },
    validationSchema: Yup.object({
      cpf: Yup.string()
        .required('Por favor, insira seu CPF')
        .cpfType('CPF inválido'),
      password: Yup.string().required('Por favor, insira sua senha'),
      keepMeSignedIn: Yup.boolean(),
    }),
    onSubmit: async (values) => {
      setLoader(true);
      try {
        const response = await authentication.auth({
          cpf: removeCpfMask(values.cpf),
          password: values.password,
          keepMeSignedIn: values.keepMeSignedIn,
        });
        saveAuth(response);
        setCurrentUser(response);
        Cookies.set('@rade-gestor/authUser', JSON.stringify(response));
        validation.values.keepMeSignedIn
          ? Cookies.set(
              '@saveCredentialsUser',
              JSON.stringify({
                keepMeSignedIn: values.keepMeSignedIn,
              }),
            )
          : Cookies.remove('@saveCredentialsUser');

        navigate('/dashboard');
      } catch (error) {
        setLoader(false);
        setErrorMessage(error instanceof InvalidCredentialsError ? error.message : 'Dados de autenticação inválidos');
        saveAuth(undefined);
        setError(true);
      }
    },
  });

  return (
    <LoginView
      error={error}
      errorMessage={errorMessage}
      loader={loader}
      validation={validation}
      passwordShow={passwordShow}
      nome={''}
      setPasswordShow={setPasswordShow}
    />
  );
};
